export interface TicRecord {
  // identifiers
  id:                   number | null;
  ticParentDocId:       number | null;

  // core
  title:                string;
  ticNumber:            string;

  // park
  ticParkId:            number | null;
  ticParkName:          string;
  ticParkAlpha:         string;
  ticParkCode:          string;
  ticParkRegionName:    string;
  ticParkPreviousName:  string;

  // security / type
  ticDocType:           string;
  ticDocTypeId:         number | null;
  ticSecurityVerification: boolean;
  ticInfoType:          string;
  ticRevisionCode:      string | null;
  ticDupeCode:          string | null;

  // project & PMIS
  ticProject:           string | null;
  ticPmisNumber:        string | null;
  ticPmisComponent:     string | null;
  ticPmisNumberHighView:string | null;
  ticAlternatePmis:     string | null;

  // alternate IDs
  ticAlternateTicId:    string | null;
  ticAlternateDoiId:    string | null;

  // authorship
  ticAuthor:            string | null;
  ticCorpAuthor:        string | null;
  ticUniformTitleCode:  string | null

  // dates
  ticCreatedDate:       string | null;
  ticModifiedDate:      string | null;
  ticPublishDate:       string | null;
  ticReceivedDate:      string | null;
  ticInfoDate:          string | null;
  ticEstimatedDate:     boolean | null;

  // retention
  ticRetentionCategory:    string;
  ticRetentionDisposition: string;

  // storage
  ticStorage:           string | null;
  ticFrcAccessionNumber:string | null;
  ticFrcBox:            string | null;
  ticFolder:            string | null;
  ticNaraAccessionNumber:string | null;
  ticNaraBox:           string | null;

  // transfer
  ticElectronicTransfer: boolean | null;

  // physical
  ticPhysicalSheetCount: number | null;
  ticTotalCalcSheetCount:number | null;
  ticOriginalMissing:    boolean;
  ticMicrofilmMissing:   boolean;
  ticMicrofilmRollNumber:string | null;
  ticMicrofilmedDate:    string | null;

  // rights & notes
  ticRights:            string | null;
  ticNpsSource:         string | null;
  ticComment:           string | null;

  // multi-selects (stored as comma-strings)
  ticSubject:           string | null;
  ticLocation:          string | null;
  ticMedia:             string | null;
  ticCondition:         string | null;

  // scale/size/url
  ticScale:             string | null;
  ticSize:              string | null;
  ticUrl:               string | null;

  // aerial‐only
  ticAerialFrames:      string | null;
  ticAerialIndex:       boolean | null;
  ticAerialControls:    boolean | null;
  ticAerialFlightId:    string | null;
  ticAerialCanNumber:  string | null; 

  // misc metadata
  ticDoiSource:         string | null;
  ticOriginSystem:      string | null;
  ticParentCollection:  string | null;
  ticPdfMergeLocation:  string | null;
  ticPdfMergeDate:      string | null;
  ticEticAdded:         string | null;
  ticCreatorName:       string | null;
  ticModifiedBy:        string | null;
  ticLitigationHold:    boolean;

  // attachments
  children: Array<{
    AssetID:            string;
    title:              string | null;
    pdfName:            string;
    pdfPageCount:       number | null;
    pdfSize:            number | null;
    collection:         string | null;
    order:              number | null;
  }>;
}

export const initialRecordState: TicRecord = {
    id: null,
    ticParentDocId: null,

    title:           '',
    ticNumber:       '',

    ticParkId:       null,
    ticParkName:     '',
    ticParkAlpha:    '',
    ticParkCode:     '',
    ticParkRegionName: '',
    ticParkPreviousName: '',

    ticDocType:      '',
    ticDocTypeId:    null,
    ticSecurityVerification: false,
    ticInfoType:     '',
    ticRevisionCode: null,
    ticDupeCode:     null,

    ticProject:      null,
    ticPmisNumber:   null,
    ticPmisComponent:null,
    ticPmisNumberHighView: null,
    ticAlternatePmis:null,
    ticAlternateTicId:null,
    ticAlternateDoiId:null,

    ticAuthor:       '',
    ticCorpAuthor:   '',
    ticUniformTitleCode: '',

    ticCreatedDate:  null,
    ticModifiedDate: null,
    ticPublishDate:  null,
    ticReceivedDate: null,
    ticInfoDate:     null,
    ticEstimatedDate:false,

    ticRetentionCategory:    '',
    ticRetentionDisposition: '',

    ticStorage:       null,
    ticFrcAccessionNumber: null,
    ticFrcBox:        null,
    ticFolder:        null,
    ticNaraAccessionNumber:null,
    ticNaraBox:       null,

    ticElectronicTransfer: false,

    ticPhysicalSheetCount: null,
    ticTotalCalcSheetCount:null,
    ticOriginalMissing:  false,
    ticMicrofilmMissing: false,
    ticMicrofilmRollNumber: null,
    ticMicrofilmedDate:  null,

    ticRights:        null,
    ticNpsSource:     null,
    ticComment:       null,

    ticSubject:       null,
    ticLocation:      null,
    ticMedia:         null,
    ticCondition:     null,

    ticScale:         null,
    ticSize:          null,
    ticUrl:           null,

    ticAerialFrames:  null,
    ticAerialIndex:   null,
    ticAerialControls:null,
    ticAerialFlightId:null,
    ticAerialCanNumber: null,

    ticDoiSource:     null,
    ticOriginSystem:  null,
    ticParentCollection: null,
    ticPdfMergeLocation: null,
    ticPdfMergeDate:  null,
    ticEticAdded:     null,
    ticCreatorName:   null,
    ticModifiedBy:    null,
    ticLitigationHold:false,

    children: [],
  };